module.exports = __webpack_public_path__ + "static/media/philosophy-not-enrolled.773b3db1.svg";